import React, { Component } from "react";
import ContentWrapper from "../../../components/common/ContentWrapper.js";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import "../../../components/admin/css/common.css";
import { history } from "../../../helper/history.js";
import { TreeMainService } from "../../../service/manage/h_tree/tree_main.service.js";
import Spinner from "react-bootstrap/Spinner";
import config from "../../../helper/config.js";
import { customerConstants } from "../../../helper/constants.js";
import ManageFormSetup from "./ManageFormSetup.js";
import SimpleReactValidator from "simple-react-validator";
import ManageFormView from "./ManageFormView.js";
import { Tooltip } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let tabTextColor;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    tabTextColor = "var(--maincolor)";
    break;
  case customerConstants.EXO_CUSTOMER2:
    tabTextColor = "var(--maincolor-cmc)";
    break;
  default:
    tabTextColor = "var(--maincolor)";
    break;
}

const privileges = {
  tabVisibility: false,
  addVisibility: false,
  editVisibility: false,
  deleteVibility: false,
  viewVisibility: false,
  isAdmin: false,
  isStudent: false,
  isTeacher: false,
};

export default class MainManageEvaluateA extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0,
      showInsertModal: false,
      showModal: false,
      isLoading: false,
      isTableDataLoading: true,
      isModified: false,
      selectedStudentId: "",
      selectedStudentTable: "",
      selectedStudent: null,
      search_id: "",
      isStudentsLoading: false,
      isSubmitting: false,
      registration_id: "",
      editVisibility: false,
      addVisibility: false,
      breadcrumb2: null,
      nodeTitle: null,
      flg_list_active: null,
      selectedStudent: null,
      selectedPackage: null,
      userType: "",
      formSetupPrivilage: privileges,
      formViewPrivilage: privileges,
      //   manageReportTitlePrivilage: privileges,
      //   manageReportSubjectPrivilage: privileges,
      privilageLoading: true,
    };
  }

  handleTabChange = (event, newValue) => {
    this.setState({ activeTab: newValue });
  };

  componentDidMount() {
    const {
      privilege_add,
      privilege_edit,
      breadcrumb2,
      nodeTitle,
      flg_list_active,
      privilege_view,
      privilege_delete,
      lg_user_id,
      lg_user_table_id,
    } = this.props.state;

    const userType = sessionStorage.getItem("userType");

    TreeMainService.getUserType(lg_user_table_id).then((response) => {
      this.setState(
        {
          breadcrumb2: breadcrumb2,
          nodeTitle,
          flg_list_active,
          userType: userType,
        },
        () => {
          this.getVisibilityCheck(privilege_add, privilege_edit);
          this.setRoleBasedPrivilege(
            privilege_add,
            privilege_edit,
            privilege_view,
            privilege_delete
          );
        }
      );
    });
  }

  getVisibilityCheck(privilege_add, privilege_edit) {
    if (privilege_add == "1") {
      this.setState({
        addVisibility: true,
      });
    }
    if (privilege_edit == "1") {
      this.setState({
        editVisibility: true,
      });
    }
  }

  setRoleBasedPrivilege(
    privilege_add,
    privilege_edit,
    privilege_view,
    privilege_delete
  ) {
    const { userType } = this.state;

    const formViewPrivilege = {
      tabVisibility: privilege_view || privilege_add,
      addVisibility: privilege_add,
      editVisibility: privilege_edit,
      deleteVisibility: privilege_delete,
      viewVisibility: privilege_view,
      showManageFormSetup: privilege_edit || privilege_delete,
    };

    // Determine which tabs should be visible
    const tabList = [];
    let defaultTab = 0; // Default to the first tab

    if (formViewPrivilege.tabVisibility) {
      if (formViewPrivilege.showManageFormSetup) {
        tabList.push({ label: "Form Setup", value: 0 });
        if (defaultTab === 0) {
          defaultTab = 0;
        }
      }
      if (formViewPrivilege.viewVisibility) {
        tabList.push({ label: "Feedback Form", value: 1 });
        if (defaultTab === 0) {
          defaultTab = 1;
        }
      }
    }

    // Update state with the tabList and the defaultTab
    this.setState({
      formViewPrivilege,
      privilageLoading: false,
      tabList,
      activeTab: tabList.length > 0 ? defaultTab : 0,
    });
  }

  render() {
    const path = history.location.pathname;

    const {
      formViewPrivilege,
      privilageLoading,
      tabList,
      activeTab,
      userType,
    } = this.state;

    const privilegeSetup = (
      <div
        className="Ttip"
        style={{ fontFamily: "Arial, sans-serif", lineHeight: "1.6" }}
      >
        <h4>Evaluate Form Privilege Breakdown</h4>
        <ol style={{ paddingLeft: "20px" }}>
          <li style={{ marginBottom: "10px" }}>
            <strong>To enable users to Submit:</strong>
            <ul>
              <li style={{ marginTop: "5px" }}>
                User with Privilege: <strong>privilege_view</strong> +{" "}
                <strong>privilege_add</strong>
                <br />
                Record restriction: <strong>Record creator</strong>
                <br />
                <ul style={{ marginTop: "5px" }}>
                  <li>Visible Tab(s):</li>
                  <ul style={{ paddingLeft: "20px" }}>
                    <li><strong>Check list Form</strong></li>
                  </ul>
                </ul>
              </li>
            </ul>
          </li>
          <li style={{ marginBottom: "10px" }}>
            <strong>To allow only the Review option:</strong>
            <ul>
              <li style={{ marginTop: "5px" }}>
                User with Privilege: <strong>privilege_view</strong>
                <br />
                Owner Restriction: <strong>Record owner</strong>
                <br />
                Dropdown Restriction: <strong>No restriction</strong>
                <br />
                <ul style={{ marginTop: "5px" }}>
                  <li>Visible Tab(s):</li>
                  <ul style={{ paddingLeft: "20px" }}>
                    <li><strong>Check list Form</strong></li>
                  </ul>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <strong>For Set up and Review access:</strong>
            <ul>
              <li style={{ marginTop: "5px" }}>
                User with Privilege: <strong>privilege_view</strong> +{" "}
                <strong>privilege_add</strong> + <strong>privilege_edit</strong>{" "}
                + <strong>privilege_delete</strong>
                <br />
                Owner Restriction: <strong>Record owner</strong>
                <br />
                Dropdown Restriction: <strong>No restriction</strong>
                <br />
                <ul style={{ marginTop: "5px" }}>
                  <li>Visible Tab(s):</li>
                  <ul style={{ paddingLeft: "20px" }}>
                    <li><strong>Form Setup</strong></li>
                    <li><strong>Check list Form</strong></li>
                  </ul>
                </ul>
              </li>
            </ul>
          </li>
        </ol>
      </div>
    );

    return (
      <div style={{ height: "90vh", overflow: "auto" }}>
        <ContentWrapper disabled={path === "/manage-search"}>
          {!formViewPrivilege ? (
            <div className="loading-container">
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            </div>
          ) : (
            <div>
              {tabList.length > 0 && (
                <Tabs
                  value={activeTab}
                  onChange={this.handleTabChange}
                  variant="scrollable"
                  scrollButtons="auto"
                  sx={{
                    "& .MuiTab-root": {
                      fontFamily: "Poppins, sans-serif",
                      textTransform: "unset",
                      letterSpacing: "-0.4px",
                      fontWeight: "600",
                    },
                    "& .Mui-selected": {
                      color: tabTextColor + " !important",
                    },
                    borderRight: 1,
                    borderColor: "divider",
                    backgroundColor: "#fff",
                  }}
                  TabIndicatorProps={{
                    style: {
                      backgroundColor: tabTextColor,
                    },
                  }}
                >
                  {tabList.map((tab) => (
                    <Tab key={tab.value} label={tab.label} value={tab.value} />
                  ))}
                  {userType === "admin" && (
                    <Tooltip title={privilegeSetup} placement="right-end" arrow>
                      <HelpIcon
                        style={{ cursor: "pointer", marginTop: "10px" }}
                      />
                    </Tooltip>
                  )}
                </Tabs>
              )}

              {!privilageLoading &&
                activeTab === 0 &&
                formViewPrivilege.showManageFormSetup && (
                  <ManageFormSetup
                    props={this.props.state}
                    formSetupPrivilage={formViewPrivilege}
                  ></ManageFormSetup>
                )}
              {!privilageLoading &&
                activeTab === 1 &&
                formViewPrivilege.tabVisibility && (
                  <ManageFormView
                    props={this.props.state}
                    formViewPrivilage={formViewPrivilege}
                  ></ManageFormView>
                )}
            </div>
          )}
        </ContentWrapper>
      </div>
    );
  }
}
